import { useEffect } from "react";
import { useBranding } from "../../context/BrandingContext";
import { PLATFORM_BRAND } from "../../config/platformBrand";

// Page-local head ownership. Never update shared BrandingContext or tenant assets.
export const AgentLoginMetadata = ({name}) => {
  const {faviconUrl}=useBranding();
  useEffect(()=>{
    const previousTitle=document.title;
    const oldIcons=[...document.querySelectorAll("link[rel='icon'],link[rel='shortcut icon']")].map(e=>e.cloneNode(true));
    const robots=document.createElement("meta");robots.name="robots";robots.content="noindex, nofollow";document.head.appendChild(robots);
    const apply=()=>{
      document.title=`Inloggen | ${name}`;
      document.querySelectorAll("link[rel='icon'],link[rel='shortcut icon']").forEach(e=>e.remove());
      const icon=document.createElement("link");icon.rel="icon";icon.href=PLATFORM_BRAND.assets.original;icon.dataset.agentLoginIcon="true";document.head.appendChild(icon);
    };
    const frame=requestAnimationFrame(apply);
    return()=>{
      cancelAnimationFrame(frame);robots.remove();
      document.querySelectorAll("link[data-agent-login-icon]").forEach(e=>e.remove());
      if(!document.querySelector("link[rel='icon']")){
        if(faviconUrl){const icon=document.createElement("link");icon.rel="icon";icon.href=faviconUrl;document.head.appendChild(icon);}
        else oldIcons.filter(e=>!e.dataset.agentLoginIcon).forEach(e=>document.head.appendChild(e));
      }
      if(document.title===`Inloggen | ${name}`)document.title=previousTitle;
    };
  },[name,faviconUrl]);
  return null;
};